<template>
  <div class="print-container">
    <div style="width: 100%;font-size: 24px;font-weight: bold;padding-bottom: 32px;text-align: center">领料单</div>
    <a-row :gutter="24">
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_production_no')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.planCode : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_order_nm')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.orderCode : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_product_name')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.productName : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_product_code')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.productCode : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_specification_model')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.standardModel : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_process_version')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.craftVersion : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_bom_version')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.bomVersion : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_scheduled_start_time')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.planStartTime : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_delivery_plan_no')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.code : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_job_make_delivery_planned_delivery_time')}}:</div>
        <div class="detail-value">{{ cardPrintData ? cardPrintData.planStockOutTime : '' }}</div>
      </a-col>
      <a-col :span="12" class="detail-box">
        <div class="detail-label">{{$t('page_console_notification_rule_notification_user')}}:</div>
        <div class="detail-value">
          {{ cardPrintData ? cardPrintData.stockOutUserNameList : '' }}
        </div>
      </a-col>
    </a-row>
    <ml-table :pagination="false" :columns="columns" :dataSource="cardPrintData.list" bordered>
    </ml-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const columns = [
  {
    title: 'page_business_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true
  },
  {
    title: 'page_business_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true
  },
  {
    title: 'page_job_make_delivery_plan_quantity',
    dataIndex: 'planNum',
    scopedSlots: { customRender: 'planNum' },
    ellipsis: true
  },
  {
    title: 'page_job_make_delivery_rea_plan_quantity',
    dataIndex: 'plannedNum',
    scopedSlots: { customRender: 'plannedNum' },
    ellipsis: true
  },
  {
    title: 'page_job_make_delivery_inventory_quantity',
    dataIndex: 'totalNum',
    scopedSlots: { customRender: 'totalNum' },
    ellipsis: true
  },
  {
    title: 'page_job_make_delivery_quantity_be_issued',
    dataIndex: 'toBeDeliveredNum',
    scopedSlots: { customRender: 'toBeDeliveredNum' },
    ellipsis: true
  },
  {
    title: 'page_job_make_delivery_demand_quantity',
    dataIndex: 'requireNum',
    scopedSlots: { customRender: 'requireNum' },
    ellipsis: true
  }
]
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['cardPrintData']),
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  mounted() {
    setTimeout(() => {
      window.print()
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.print-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 940px;
  // margin: 64px 0;
  padding: 40px 16px 0;
  .detail-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 16px;
    .detail-label {
      width: 30%;
      text-align: right;
      font-weight: bold;
    }
    .detail-value {
      width: 70%;
      padding-left: 16px;
    }
  }
}
</style>
